import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trash2 } from 'feather-icons-react/build/IconComponents';
import CustomPropTypes from 'CustomPropTypes';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup } from 'react-bootstrap';

const initData = {
  id: 0,
  shipId: 0,
  partnumber: '',
  description: '',
  noOfBoxes: '',
  qtyperBox: '',
  noOfPallets: '',
  plannedShipQty: '',
  isDeleted: '',
  poNumber: '',
};

const PartsTable = ({ data, onChanges }) => {
  const [partInputs, setPartInputs] = useState(initData);
  const [action, setAction] = useState('add');
  const [parts, setParts] = useState(data || []);

  const updatePartField = (field, value) => {
    setPartInputs(prevPartInputs => ({
      ...prevPartInputs,
      [field]: value,
    }));
  };

  const addPart = () => {
    const newParts = [
      ...parts,
      {
        ...partInputs,
        id: Math.floor(Math.random() * 101),
      },
    ];
    setParts(newParts);
    setPartInputs(initData);
    if (onChanges) onChanges(newParts);
  }; 

  const updatePart = () => {
    let selectedIndex = -1;
    const isPartAvailable = parts.some((part,index) => {
      const selectedId = part.id == partInputs.id;
      if(selectedId)
        selectedIndex = index;
      return selectedId;
    });
    const newParts = [
      ...parts
    ];
    if(isPartAvailable) {
      // Preserve totalScannedQuantity from original part
      const originalPart = parts[selectedIndex];
      newParts[selectedIndex] = {
        ...partInputs,
        totalScannedQuantity: originalPart.totalScannedQuantity
      };
    }
    setParts(newParts);
    setPartInputs(initData);
    setAction('add');
    if (onChanges) onChanges(newParts);
  }; 

  const editPart = id => {
    setAction('edit');
    const editedPart = parts.filter(part => part.id == id)[0];
    // Exclude totalScannedQuantity from editable fields
    const { totalScannedQuantity, ...editableFields } = editedPart;
    setPartInputs(editableFields);
  };

  const clearPart = () => {
    setAction('add');
    setPartInputs(initData);
  }

  const removePart = id => {
    const newParts = parts.filter(part => part.id !== id);
    if(action == 'edit' && partInputs.id == id)
      setPartInputs(initData);
    setParts(newParts);
    if (onChanges) onChanges(newParts);
  };

  const isValidInputs = () => {
    const { partnumber, description, poNumber, noOfBoxes, qtyperBox, noOfPallets, plannedShipQty } =
      partInputs;
    return (
      partnumber &&
      description &&
      poNumber &&
      noOfBoxes &&
      qtyperBox &&
      noOfPallets &&
      plannedShipQty
    );
  };

  useEffect(() => {
    if (onChanges) onChanges(parts);
  }, [parts, onChanges]);

  useEffect(() => {
    setParts(data || []);
  }, [data]);

  return (
    <div className="row border">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">Parts List</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Part Number</th>
                    <th>Description</th>
                    <th>PO Number</th>
                    <th>Number of Boxes</th>
                    <th>Qty Per Box</th>
                    <th>Number of Pallets</th>
                    <th>Planned ship Qty</th>
                    <th>Scanned Qty</th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="text"
                          value={partInputs.partnumber}
                          name="partnumber"
                          onChange={e => updatePartField('partnumber', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="text"
                          value={partInputs.description}
                          name="description"
                          onChange={e => updatePartField('description', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="text"
                          value={partInputs.poNumber}
                          name="poNumber"
                          onChange={e => updatePartField('poNumber', e.target.value)}
                          className="form-control border rounded"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="number"
                          value={partInputs.noOfBoxes}
                          name="noOfBoxes"
                          onChange={e => updatePartField('noOfBoxes', e.target.value)}
                          className="form-control border rounded"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="number"
                          value={partInputs.qtyperBox}
                          name="qtyperBox"
                          onChange={e => updatePartField('qtyperBox', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="number"
                          value={partInputs.noOfPallets}
                          name="noOfPallets"
                          onChange={e => updatePartField('noOfPallets', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </th>
                    <th>
                      <div className="input-blocks">
                        <input
                          type="number"
                          value={partInputs.plannedShipQty}
                          name="plannedShipQty"
                          onChange={e => updatePartField('plannedShipQty', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </th>
                    <th>
                      {/* Scanned Qty is read-only, not editable */}
                    </th>
                    <th>
                      <button
                        type="button"
                        className="btn btn-info mb-3"
                        onClick={action == 'add' ? addPart : updatePart}
                        disabled={!isValidInputs()}
                      >
                        {action == 'add' ? 'Add' : 'Update'}
                      </button>
                    </th>
                    <th>
                    <button
                        type="button"
                        className="btn btn-danger mb-3"
                        onClick={clearPart}
                      >
                        Clear
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {parts.map(part => (
                    <tr key={part.id}>
                      <td className="p-0">{part.partnumber}</td>
                      <td className="p-0">{part.description}</td>
                      <td className="p-0">{part.poNumber}</td>
                      <td className="p-0">{part.noOfBoxes}</td>
                      <td className="p-0">{part.qtyperBox}</td>
                      <td className="p-0">{part.noOfPallets}</td>
                      <td className="p-0">{part.plannedShipQty}</td>
                      <td className="p-0">{part.totalScannedQuantity ?? 'N/A'}</td>
                      <td>
                        <a
                          href="javascript:void(0);"
                          onClick={() => editPart(part.id)}
                          className="btn btn-icon btn-sm btn-soft-info rounded-pill"
                        >
                          <i className="feather-edit"></i>
                        </a>
                      </td>
                      <td className="p-0">
                        <a
                          href="javascript:void(0);"
                          onClick={() => removePart(part.id)}
                          className="btn btn-icon btn-sm btn-soft-danger rounded-pill"
                        >
                          <i className="feather-trash"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PartsTable.defaultProps = {
  onChanges: () => {},
};

PartsTable.propTypes = {
  onChanges: PropTypes.func,
  data: CustomPropTypes.Parts,
};

export default PartsTable;
